import { render } from "./BaseAccordion.vue?vue&type=template&id=f133fd9a&scoped=true"
import script from "./BaseAccordion.vue?vue&type=script&lang=js"
export * from "./BaseAccordion.vue?vue&type=script&lang=js"

import "./BaseAccordion.vue?vue&type=style&index=0&id=f133fd9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f133fd9a"]])

export default __exports__